import React from "react";
import Animacion from "./animacion";
import { StickyContainer, Sticky } from "react-sticky";
import { Link as Boton } from "react-router-dom";
import Container from "./styled";

export default function Confirmacion() {

  return (
    <Container>
      {/* Max Width Container */}
      <div id="max-width-container">
        <div id="formulario-container">
          <h3 className="opacidad05">¡Recibimos tu referido!</h3>
          <p className="opacidad05" id="completa">
            ¡Muchas gracias! Pronto nos pondremos en contacto con vos y tu
            referido.
          </p>
          <Animacion></Animacion>
        </div>
        <StickyContainer>
          <Sticky>
            {({ style }) => (
              <div id="plazos-container" className="opacidad05" style={style}>
                <p>Ver más</p>
                <Boton to="/contacto">Contacto</Boton>
                <Boton to="/sobre-nosotros">Sobre nosotros</Boton>
                <Boton to="/politicas-y-terminos">Políticas y términos</Boton>
                <Boton to="/forma-parte">Forma parte</Boton>
              </div>
            )}
          </Sticky>
        </StickyContainer>
      </div>
    </Container>
  );
}
